import { useEffect, useMemo } from "react";
import { PropertyEndpoint } from "../api";
import { usePropertyStore } from "../store/usePropertyStore";
import Navbar from "../components/global-components/navbar-v4";
import BannerV6 from "../components/section-components/banner-v6";
import ProductListing from "../components/section-components/product-listing";

const Beranda = () => {
	const { properties, setProperties } = usePropertyStore();

	// Fetch data properti
	useEffect(() => {
		const propertyEndpoint = new PropertyEndpoint();

		const fetchPropertyData = async () => {
			const response = await propertyEndpoint.getProperties();

			const filteredProperty = response;
			setProperties(filteredProperty);
		};

		if (properties.length === 0) {
			fetchPropertyData();
		}
	}, []);

	const chooseType = useMemo(() => {
		if (!properties || properties.length === 0) {
			return {
				property_type: [],
				province: [],
				city: [],
			};
		}

		const types = [...new Set(properties.map((p) => p.property_type))];
		const provinces = [...new Set(properties.map((p) => p.province))];
		const cities = [...new Set(properties.map((p) => p.city))];

		return {
			property_type: types,
			province: provinces,
			city: cities,
		};
	}, [properties]);

	return (
		<div>
			<Navbar CustomClass="ltn__header-transparent gradient-color-2" />
			<BannerV6 chooseType={chooseType} />
			<ProductListing propertyData={properties} />
		</div>
	);
};

export default Beranda;
